import { TroubleShootingMockService } from './core/service/mock-api/troubleshooting.service';
import {
	APP_INITIALIZER,
	CUSTOM_ELEMENTS_SCHEMA,
	Injector,
	NgModule,
} from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import en from '@angular/common/locales/en';
import it from '@angular/common/locales/it';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { BaseComponent } from './pages/base/base.component';
import { LayoutModule } from './layout/layout.module';
import { SidebarConfigService } from './core/service/app/sidebar-config.service';
import {
	provideHttpClient,
	withInterceptorsFromDi,
} from '@angular/common/http';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgZorroModule } from './layout/ng-zorro/ng-zorro.module';
import { TranslationService } from './core/service/app/translate.service';
import { IconDefinition } from '@ant-design/icons-angular';
import { NZ_ICONS } from 'ng-zorro-antd/icon';
import * as AllIcons from '@ant-design/icons-angular/icons';
import { NZ_DATE_CONFIG, NZ_I18N, en_US, it_IT } from 'ng-zorro-antd/i18n';
import { registerLocaleData } from '@angular/common';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { KeycloakService, KeycloakAngularModule } from 'keycloak-angular';
import { KeycloakInitializer } from '../app/core/keycloak/keycloak-init';
import { FormsModule } from '@angular/forms';
// import { HomeComponent } from './pages/home/home.component';
import { FilterChangeService } from './core/service/api/filter-change.service';
// import { ListComponent } from './pages/managment/account/list/list.component';
import { CapitalizePipe } from './core/config/pipe/capitalize.pipe';
import { IdentityComponent } from './pages/identity/identity.component';
import { LocationGroupListComponent } from './pages/managment/location-group/list/location-group-list.component';
import { StoreModule } from '@ngrx/store';
import { filterReducer } from './core/store/filter/filter.reducer';
import { GodUserListComponent } from './pages/managment/god-user/list/god-user-list.component';

import { InvitationsService } from './core/service/api/invitations.service';
import { environment } from './environment/environment';
import { InvitationsService_Mock } from './core/service/mock-api/invitation_mock.service';
import { AccountListComponent } from './pages/managment/account/list/list.component';
import { TroubleShootingService } from './core/service/api/troubleshooting.service';
import { NzResizeObserverDirective } from 'ng-zorro-antd/cdk/resize-observer';
import { IdentityService } from './core/service/api/identity.service';
import { IdentityMockService } from './core/service/mock-api/identity.service';

const antDesignIcons = AllIcons as {
	[key: string]: IconDefinition;
};
const icons: IconDefinition[] = Object.keys(antDesignIcons).map(
	(key) => antDesignIcons[key],
);
registerLocaleData(en, 'en');
registerLocaleData(it, 'it');
@NgModule({
	declarations: [
		AppComponent,
		BaseComponent,
		// ListComponent,
		CapitalizePipe,
		IdentityComponent,
		LocationGroupListComponent,
		GodUserListComponent,
		AccountListComponent,
		// HomeComponent,
	],
	bootstrap: [AppComponent],
	imports: [
		LayoutModule,
		BrowserModule,
		AppRoutingModule,
		BrowserAnimationsModule,
		NgZorroModule,
		TranslateModule.forRoot(),
		KeycloakAngularModule,
		FormsModule,
		StoreModule.forRoot({}, {}),
		StoreModule.forFeature('filter', filterReducer),
		NzResizeObserverDirective,
	],
	providers: [
		{
			provide: APP_INITIALIZER,
			useFactory: KeycloakInitializer,
			multi: true,
			deps: [KeycloakService],
		},
		{ provide: NZ_ICONS, useValue: icons },
		{ provide: NZ_DATE_CONFIG, useValue: { firstDayOfWeek: 1 } },
		{ provide: NZ_I18N, useValue: it_IT },
		SidebarConfigService,
		TranslationService,
		TranslateService,
		FilterChangeService,
		{
			provide: InvitationsService,
			useClass: environment.useMock
				? InvitationsService_Mock
				: InvitationsService,
		},
		{
			provide: IdentityService,
			useClass: environment.useMock
				? IdentityMockService
				: IdentityService,
		},

		{
			provide: TroubleShootingService,
			useClass: environment.useMock
				? TroubleShootingMockService
				: TroubleShootingService,
		},

		provideHttpClient(withInterceptorsFromDi()),
	],
})
export class AppModule {
	static injector: Injector;
	constructor(injector: Injector) {
		AppModule.injector = injector;
	}
}
